import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import FooterComp from '../components/FooterComp';
import { Container } from 'react-bootstrap'
import { getDailyQn, updateDailyQn, essentialQnUpdated } from '../hooks/question'
import { SnackBar } from '../hooks/Common'
import Questionnaire from "../components/Questionnaire"
import { useNavigate } from 'react-router-dom'

const mapStateToProps = (state) => {
  return {
    question: state.question,
    auth: state.auth
  }
}

const mapDispatchToProps = dispatch => ({
  getDailyQn: (id) => dispatch(getDailyQn(id)),
  updateDailyQn: (data, id) => dispatch(updateDailyQn(data, id)),
  essentialQnUpdated: () => dispatch(essentialQnUpdated()),
  SnackBar: (show, message, variant) => dispatch(SnackBar(show, message, variant))
});

const getAllQuestions = (array) => {
  var check = true
  for (let i = 0; i < array.length; i++) {
    for (let index = 0; index < array[i].questions.length; index++) {
      if (array[i].questions[index].user_answers == null) {
        check = false
      }
    }
  }
  return check
}

const NavigateOnStateChange = ({ shouldNavigate, to }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(to);
    }
  }, [shouldNavigate, navigate, to]);

  return null;
}

class FeelAtTheMoment extends PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      start: null,
      question: null,
      total: null,
      id: null,
      shouldNavigate: false,
      path: null
    }
  }

  componentDidMount = () => {
    if (this.state.start === null && this.props.question.daily !== null) {
      this.setState({
        question: this.props.question.daily,
        start: 1,
        total: this.props.question.daily.length
      })
    }
    if (this.props.auth.user !== null) {
      this.setState({ id: this.props.auth.user.id })
    }
    this.props.getDailyQn(this.props.auth.user !== null ? this.props.auth.user.id : null)
  }

  componentDidUpdate = () => {
    if (this.state.start === null && this.props.question.daily !== null) {
      this.setState({
        question: this.props.question.daily,
        start: 1,
        total: this.props.question.daily.length
      })
    }

    if (this.props.question.questionUpdated == "daily") {
      this.props.essentialQnUpdated()
      this.setState({
        shouldNavigate: true,
        path: "/alertness"
      })
    }
  }

  handleAnswerChange = (parentIndex, childIndex, answer) => {
    this.setState({
      question: Object.values({
        ...this.state.question,
        [parentIndex]: {
          ...this.state.question[parentIndex],
          questions: Object.values({
            ...this.state.question[parentIndex].questions,
            [childIndex]: {
              ...this.state.question[parentIndex].questions[childIndex],
              user_answers: answer
            }
          })
        }
      })
    })
  }

  handleCheckboxChange = (parentIndex, childIndex, answer) => {
    const { question } = this.state

    const user_answers = question[parentIndex].questions[childIndex].user_answers || []

    const updatedUserAnswers = user_answers.includes(answer)
      ? user_answers.filter((id) => id !== answer)
      : [...user_answers, answer];

    this.setState({
      question: question.map((parent, pIndex) => {
        if (pIndex === parentIndex) {
          return {
            ...parent,
            questions: parent.questions.map((child, cIndex) => {
              if (cIndex === childIndex) {
                return {
                  ...child,
                  user_answers: updatedUserAnswers.length != 0 ? updatedUserAnswers : null,
                }
              }
              return child;
            }),
          };
        }
        return parent;
      })
    })
  }

  handleNext = () => {
    const { question } = this.state
    if (getAllQuestions(question)) {
      this.props.updateDailyQn(question, this.state.id)
    } else {
      this.props.SnackBar(true, 'Please complete all questions', 'danger')
    }
  }

  handleBack = () => {
    this.setState({
      shouldNavigate: true,
      path: "/dashboard"
    })
  }

  render() {
    return <Fragment>
      <NavbarComp access_token={true}/>

      <div className="page-sections">
        <div className='onboarding-wrap'>
          <Container>
            <div className='onboarding-contents'>
              <h2 className='main-title-style'>HOW DO YOU FEEL AT THE MOMENT?</h2>
              <div className='onboarding-questions-list'>
                {this.state.question !== null ? this.state.question.map((data, parentIndex) => {
                  return <Questionnaire
                    allShow={true}
                    parentIndex={parentIndex}
                    data={data}
                    start={this.state.start}
                    handleAnswerChange={(childIndex, answer) => this.handleAnswerChange(parentIndex, childIndex, answer)}
                    handleCheckboxChange={(childIndex, answer) => this.handleCheckboxChange(parentIndex, childIndex, answer)}
                  />
                }) : null}
                <div className='onboarding-back-next-btns'>
                  <button className='back-btn' onClick={this.handleBack}>Leave</button>
                  <button className='next-btn' onClick={this.handleNext}>Next</button>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
      <FooterComp />
      <NavigateOnStateChange shouldNavigate={this.state.shouldNavigate} to={this.state.path} />

    </Fragment>
  }
}

FeelAtTheMoment.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(FeelAtTheMoment);
